import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { UserX, LogOut } from 'lucide-react';
import { ErrorState } from '../../components/ui/ErrorState';
import { Button } from '../../components/ui/Button';
import { logoutUser } from '../../features/auth/authThunks';

/**
 * A session whose profile has no workspace yet: `kam`, or an account with no
 * profile this app knows.
 *
 * The router used to have nowhere to put them, and bounced them between
 * `/login` and `/dashboard` for as long as the tab stayed open.
 */
export const UnsupportedProfile = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-ninja-gray dark:bg-[#0f0f0f] p-4">
      <ErrorState
        icon={UserX}
        title="Tu perfil todavía no está disponible"
        description="Esta versión de NinjaHubs aún no tiene una sección para tu tipo de cuenta."
      >
        <Button variant="primary" icon={LogOut} onClick={() => dispatch(logoutUser(navigate))}>
          Cerrar sesión
        </Button>
      </ErrorState>
    </div>
  );
};
